import { useState, useContext } from "react";
import AuctionSvg from "../../Icons/AuctionSvg";
import {
  SectionContainerBase,
  TwoColumnSectionBase,
  CenteredGridWithHeading,
  IconTitleDescriptionActionCard,
  ImageOverlay,
} from "@reusejs/react";
import SectionHeading from "../SectionHeading";
import { Context, getWatermarkedImgixUrl, payloadToUrl } from "services";
import { useRouter } from "next/router";

const ImageSection = (props: any) => {
  return (
    <div className="relative mt-10 h-full rounded-md lg:mt-0 overflow-hidden">
      <ImageOverlay
        src={getWatermarkedImgixUrl(
          `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/${
            props.assetType === "residential"
              ? "ed6dacf8-d679-473f-aebf-d9851217a66a"
              : props.assetType === "commercial"
              ? "bd2ee30d-e1f4-4912-92c7-c2ecb1781792"
              : "d8415810-1568-4391-bf71-78e6aa801dce"
          }?fit=fill&w=576&h=624&auto=format`,
        )}
        width={576}
        height={624}
        placeholderSrc={
          props.assetType === "residential"
            ? getWatermarkedImgixUrl(
                `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/5f5054dc-b5b5-44c8-8c0e-e90b981f17de?fit=crop&w=576&h=624&auto=format`,
              )
            : props.assetType === "commercial"
            ? getWatermarkedImgixUrl(
                `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/1d41376d-0203-4311-9533-40198e5f8c35?fit=crop&w=576&h=624&auto=format`,
              )
            : getWatermarkedImgixUrl(
                `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/96512031-3c35-47ae-bbf3-757336f15530?fit=crop&w=576&h=624&auto=format`,
              )
        }
        bottomLeft={
          <div className="text-white font-extrabold">{100}+ Properties</div>
        }
        bottomRight={<AuctionSvg />}
        altName={
          props.property?.asset?.name === "residential"
            ? "residential-auction-property"
            : props.property?.asset?.name === "commercial"
            ? "commercial-auction-property"
            : "industrial-auction-property"
        }
      />
    </div>
  );
};

const Footer = (props: any) => {
  return (
    <div className="mt-4">
      <p className="text-sm italic text-gray-500">
        <></>
      </p>
    </div>
  );
};

const Actions = (props: any) => {
  const router = useRouter();
  const { searchForm }: any = useContext(Context);
  const handleSubmit = () => {
    searchForm.value.sub_asset_type = "";
    searchForm.value.state = "";
    searchForm.value.city = "";
    searchForm.value.reserve_price = "";
    searchForm.value.institutes = "";
    searchForm.value.filter_by = "";
    searchForm.value.sort_by = "";
    searchForm.value.total = "";
    searchForm.setField("asset_type", props.assetType);
    payloadToUrl(router, searchForm.value);
  };
  return (
    <div
      className="text-blue-600 cursor-pointer font-medium"
      onClick={() => handleSubmit()}
    >
      {"Explore >"}
    </div>
  );
};

let leftSectionItems = [
  {
    title: "Residential assets",
    value: "residential",
    description:
      "Planning to buy a residential house, villa, flat, or residential land.",
    actions: (
      <Actions assetType={{ label: "Residential", value: "residential" }} />
    ),
  },
  {
    title: "Commercial assets",
    value: "commercial",
    description:
      "Planning to buy Office space, Shopping Malls, commercial land, shops, offices.",
    actions: (
      <Actions assetType={{ label: "Commercial", value: "commercial" }} />
    ),
  },
  {
    title: "Industrial assets",
    value: "industrial",
    description:
      "Planning to buy Industrial Lands, Godowns, Shed with Plant and Machinery.",
    actions: (
      <Actions assetType={{ label: "Industrial", value: "industrial" }} />
    ),
  },
];

export default function ExploreComponent() {
  const [assetType, setAssetType] = useState("residential");

  const DetailsSection = () => {
    let detailsSectionHeading = {
      title: "Explore auction properties",
      description:
        "Looking for a property you have always dreamed of? Experience a seamless choice of properties and stellar support by our experts at Auction Bazaar.",
    };
    return (
      <CenteredGridWithHeading
        headingSection={
          <SectionHeading
            title={detailsSectionHeading.title}
            description={detailsSectionHeading.description}
            itemTitleDescriptionCardBaseClasses={{
              titleWrapper: "text-left",
              titleStyles: "text-2xl lg:text-3xl font-extrabold sm:text-4xl",
              descriptionWrapper: "text-left",
              descriptionStyles:
                "mt-3 text-sm lg:text-lg sm:mt-4 text-gray-500",
            }}
          />
        }
        footerSection={<Footer />}
        sectionContentData={leftSectionItems}
        itemsRenderer={ItemRendererComponent}
        centeredGridBaseClasses={{
          gridClasses: "sm:space-y-0 grid grid-cols-1  py-2",
          gridWrapper: "mt-4 border-b-2 border-t-2",
          verticalWrapperPadding: "py-0",
        }}
      />
    );
  };

  const ItemRendererComponent = (props?: any) => {
    return (
      <>
        {props.items.map((item?: any, index?: number) => {
          return (
            <div key={index}>
              {assetType === item.value ? (
                <div onMouseEnter={() => setAssetType(item.value)} key={index}>
                  <IconTitleDescriptionActionCard
                    title={item.title}
                    icon={item.icon}
                    description={item.description}
                    iconPosition="top-center"
                    actions={item.actions}
                    itemTitleDescriptionCardBaseClasses={{
                      wrapper:
                        "relative pl-4 py-4 bg-gray-100  border-l-4 border-blue-600 group",
                      titleWrapper: "mt-2",
                      titleStyles:
                        "text-lg leading-6 text-blue-900 group-hover:text-gray-900 font-bold",
                      descriptionWrapper: "mt-2",
                      descriptionStyles:
                        "text-sm lg:text-base text-gray-500 font-medium",
                      actionWrapper: "mt-2",
                    }}
                  />
                </div>
              ) : (
                <div onMouseEnter={() => setAssetType(item.value)} key={index}>
                  <IconTitleDescriptionActionCard
                    title={item.title}
                    icon={item.icon}
                    description={item.description}
                    iconPosition="top-center"
                    actions={item.actions}
                    itemTitleDescriptionCardBaseClasses={{
                      wrapper:
                        "relative pl-4 py-4 bg-white hover:bg-gray-100 border-l-4 border-transparent hover:border-l-4 hover:border-blue-600 group",
                      titleWrapper: "mt-2",
                      titleStyles:
                        "text-lg leading-6 text-blue-900 group-hover:text-gray-900 font-bold",
                      descriptionWrapper: "mt-2",
                      descriptionStyles:
                        "text-sm lg:text-base text-gray-500 font-medium",
                      actionWrapper: "mt-2",
                    }}
                  />
                </div>
              )}
            </div>
          );
        })}
      </>
    );
  };

  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "py-10 md:py-20",
      }}
    >
      <TwoColumnSectionBase
        firstColumnEl={<DetailsSection />}
        secondColumnEl={<ImageSection assetType={assetType} />}
        twoColumnSectionBaseClasses={{
          firstElWrapperStyles: "w-full md:w-1/2",
          secondElWrapperStyles: "w-full md:w-1/2 px-8",
          columnsFlexWrapperStyles:
            "flex items-center  justify-between flex-col md:flex-row",
        }}
      />
    </SectionContainerBase>
  );
}
